export default "__VITE_ASSET__B9H3eB03__"